import {fetch} from './fetch';
import {uuid,getMoble} from './utils'
import { ccServer } from './base'

export class ccHttpClient extends ccServer{
  constructor() {
  	super();
  }
    /*
       获取cc server Url
   * */
  location(data,baseUrl) {
    let commondata = {
        tag:null,
        cmd:'lookup',
        ver:'4.0',
        dev:'',
        devt:'web',
        os:navigator.userAgent.toLowerCase()
    };
    let paramsData = Object.assign(commondata,data);
    let params = {
        options:{
            url:'/login/location?cmd=lookup',
            method:'post',
            data:JSON.stringify(paramsData)
        }
    };
    return  new Promise((resolve, reject) => {
	   fetch(params,baseUrl).then(res=>{
	     this.serverUrl = res.data.serverAddress;
	     resolve(true);
	    }).catch(err=>{console.log(err);reject(false)});
    })
 
    
  }
	/*注册cc账号
	* 参数：user:{"user":"dawei.lin@263cc.com","passwd":"qqq111"}
	*       info:{"email":"dawei.lin@net263.com","tel":"0412-7897122","phone":"18510640007","fax":"84290263"}
	* */
 async registerCC(user,locationbaseUrl){
    let mobel = getMoble();
    let commonData = {
          user,
          info:{
              email:`${mobel}@net263.com`,
              tel:mobel,
              phone:mobel,
              fax:mobel
          }
      };
     let params = {
        options:{
            url:'/regist?cmd=register',
            method:'post',
            data:JSON.stringify(commonData)
        }
    };
    var locationInfo = await this.location(locationbaseUrl);
    if(!locationInfo) return false;
    let baseUrl = ccServer.findUrl(1);
    return fetch(params,baseUrl);
    
  }
   /***登录CC***/
   async ulogin(data,locationbaseUrl) {
    let commondata = {
        tag:'',
        cmd:'auth',
        ver:'4.0',
        dev:'web',
        devt:'web',
        os:navigator.userAgent.toLowerCase(),
        captcha:85
    };
    let paramsData = Object.assign(commondata,data);
    console.log(paramsData);
    let params = {
        options:{
            url:'/login/ulogin?cmd=auth',
            method:'post',
            data:JSON.stringify(paramsData)
        }
    };
     var locationInfo = await this.location(locationbaseUrl);
     if(!locationInfo) return false;
	 let baseUrl = ccServer.findUrl(1);
     return fetch(params,baseUrl);
  }
  /***使用sessionKey 认证登录cc**/
  async logAuth(data,bindid) {
	  let commondata = {
	    tag:'',
	    cmd:'sa',
	    ver:'4.0',
	    dev:'web',
	    devt:'web',
	    os:navigator.userAgent.toLowerCase(),
	    captcha:85
	  };
	  let paramsData = Object.assign(commondata,data);
	  let params = {
	    options:{
	      url:`/login/ulogin?cmd=auth&bindid=${bindid}`,
	      method:'post',
	      data:JSON.stringify(paramsData)
	    }
	  };
	 var locationInfo = await this.location(locationbaseUrl);
     if(!locationInfo) return false;
	 let baseUrl = ccServer.findUrl(1);
     return fetch(params,baseUrl);
   }
  /**获取验证码**/
  getaptcha(paramsData){
    let params = {
        options:{
            url:`/login/ulogin?cmd=captcha&captchas=15`,
            method:'post',
            data:JSON.stringify(paramsData)
        }
    };
    let baseUrl = ccServer.findUrl(1);
    return fetch(params,baseUrl);
  }
  //type 5
  department(data) {
    let commonData = {
        cmd:'get',
        obj:'department',
        tag:'',
        updatetime:0,
        version:'',
        ver:'1.0.0',
        dev:'web',
        devt:'web',
        os:navigator.userAgent.toLowerCase()
    };
    let paramsData = Object.assign(commonData,data);
    let params = {
        options:{
            url:'/resource/userdata?cmd=get&obj=department',
            method:'post',
            data:JSON.stringify(paramsData)
        }
    };
    let baseUrl = ccServer.findUrl(5);
    return fetch(params,baseUrl)
  }
  departmentuser(data) {
    let commonData = {
        cmd:'get',
        obj:'department_user',
        tag:'',
        updatetime:0,
        version:'',
        ver:'1.0.0',
        dev:'web',
        devt:'web',
        os:navigator.userAgent.toLowerCase()
    };
    let paramsData = Object.assign(commonData,data);
    let params = {
        options:{
            url:'/resource/userdata?cmd=get&obj=department_user',
            method:'post',
            data:JSON.stringify(paramsData)
        }
    };
    let baseUrl = ccServer.findUrl(5);
    return fetch(params,baseUrl)
  }
  user(data) {
    let commonData = {
        cmd:'get',
        obj:'user',
        tag:'',
        updatetime:0,
        version:'',
        ver:'1.0.0',
        dev:'web',
        devt:'web',
        os:navigator.userAgent.toLowerCase()
    };
    let paramsData = Object.assign(commonData,data);
    let params = {
        options:{
            url:'/resource/userdata?cmd=get&obj=user',
            method:'post',
            data:JSON.stringify(paramsData)
        }
    };
    let baseUrl = ccServer.findUrl(5);
    return fetch(params,baseUrl)
  }
  orgcontacts(data) {
    let commonData = {
        cmd:'download',
        obj:'orgcontacts',
        tag:'',
        version:'',
        ver:'1.0.0',
        dev:'web',
        devt:'web',
        os:navigator.userAgent.toLowerCase()
    };
    let paramsData = Object.assign(commonData,data);
    let params = {
        options:{
            url:'/resource/userdata?cmd=download&obj=orgcontacts',
            method:'post',
            data:JSON.stringify(paramsData)
        }
    };
    let baseUrl = ccServer.findUrl(5);
    return fetch(params,baseUrl)
}
  getGroupMember(data){
    let commonData = {
        cmd:'get',
        obj:'fixedgroups_user',
        tag:'',
        updatetime:0,
        ver:'1.0.0',
        dev:'web',
        devt:'web',
        os:navigator.userAgent.toLowerCase()
    };
    let paramsData = Object.assign(commonData,data);
    let params = {
        options:{
            url:'/resource/userdata?cmd=get&obj=fixedgroups_user',
            method:'post',
            data:JSON.stringify(paramsData)
        }
    };
    let baseUrl = ccServer.findUrl(5);
    return fetch(params,baseUrl)
}
 getGroupInfo(data){
    let commonData = {
        cmd:'get',
        obj:'fixedgroups',
        tag:'',
        updatetime:0,
        ver:'1.0.0',
        dev:'web',
        devt:'web',
        os:navigator.userAgent.toLowerCase()
    };
    let paramsData = Object.assign(commonData,data);
    let params = {
        options:{
            url:'/resource/userdata?cmd=get&obj=fixedgroups',
            method:'post',
            data:JSON.stringify(paramsData)
        }
    };
    let baseUrl = ccServer.findUrl(5);
    return fetch(params,baseUrl)
  }
}
/*注册cc账号
* 参数：user:{"user":"dawei.lin@263cc.com","passwd":"qqq111"}
*       info:{"email":"dawei.lin@net263.com","tel":"0412-7897122","phone":"18510640007","fax":"84290263"}
* */
export function registerCC(user){
    let mobel = getMoble();
    let commonData = {
          user,
          info:{
              email:`${mobel}@net263.com`,
              tel:mobel,
              phone:mobel,
              fax:mobel
          }
      };
     let params = {
        options:{
            url:'/regist?cmd=register',
            method:'post',
            data:JSON.stringify(commonData)
        }
    };
    return fetch(params);
}
export function location(data) {
    let commondata = {
        tag:null,
        cmd:'lookup',
        ver:'4.0',
        dev:'',
        devt:'web',
        os:navigator.userAgent.toLowerCase()
    };
    let paramsData = Object.assign(commondata,data);
    let params = {
        options:{
            url:'/login/location?cmd=lookup',
            method:'post',
            data:JSON.stringify(paramsData)
        }
    };
    return fetch(params);
}
//客户端登录
export function ulogin(data) {
    let commondata = {
        tag:'',
        cmd:'auth',
        ver:'4.0',
        dev:'web',
        devt:'web',
        os:navigator.userAgent.toLowerCase(),
        captcha:85
    };
    let paramsData = Object.assign(commondata,data);
    console.log(paramsData);
    let params = {
        options:{
            url:'/login/ulogin?cmd=auth',
            method:'post',
            data:JSON.stringify(paramsData)
        }
    };
    return fetch(params);
}
export function logAuth(data,bindid) {
  let commondata = {
    tag:'',
    cmd:'sa',
    ver:'4.0',
    dev:'web',
    devt:'web',
    os:navigator.userAgent.toLowerCase(),
    captcha:85
  };
  let paramsData = Object.assign(commondata,data);
  let params = {
    options:{
      url:`/login/ulogin?cmd=auth&bindid=${bindid}`,
      method:'post',
      data:JSON.stringify(paramsData)
    }
  };
  return fetch(params);
}
//获取验证码
export function getaptcha(paramsData){
    let params = {
        options:{
            url:`/login/ulogin?cmd=captcha&captchas=15`,
            method:'post',
            data:JSON.stringify(paramsData)
        }
    };
    return fetch(params);
}
//获取用户信息
/***获取组织通讯录***/
//获取部门信息
export function department(data) {
    let commonData = {
        cmd:'get',
        obj:'department',
        tag:'',
        updatetime:0,
        version:'',
        ver:'1.0.0',
        dev:'web',
        devt:'web',
        os:navigator.userAgent.toLowerCase()
    };
    let paramsData = Object.assign(commonData,data);
    let params = {
        options:{
            url:'/resource/userdata?cmd=get&obj=department',
            method:'post',
            data:JSON.stringify(paramsData)
        }
    };
    return fetch(params)
}
//获取部门用户信息
export  function departmentuser(data) {
    let commonData = {
        cmd:'get',
        obj:'department_user',
        tag:'',
        updatetime:0,
        version:'',
        ver:'1.0.0',
        dev:'web',
        devt:'web',
        os:navigator.userAgent.toLowerCase()
    };
    let paramsData = Object.assign(commonData,data);
    let params = {
        options:{
            url:'/resource/userdata?cmd=get&obj=department_user',
            method:'post',
            data:JSON.stringify(paramsData)
        }
    };
    return fetch(params)
}
//获取用户信息
export function user(data) {
    let commonData = {
        cmd:'get',
        obj:'user',
        tag:'',
        updatetime:0,
        version:'',
        ver:'1.0.0',
        dev:'web',
        devt:'web',
        os:navigator.userAgent.toLowerCase()
    };
    let paramsData = Object.assign(commonData,data);
    let params = {
        options:{
            url:'/resource/userdata?cmd=get&obj=user',
            method:'post',
            data:JSON.stringify(paramsData)
        }
    };
    return fetch(params)
}
//获取组织所有用户
export function orgcontacts(data) {
    let commonData = {
        cmd:'download',
        obj:'orgcontacts',
        tag:'',
        version:'',
        ver:'1.0.0',
        dev:'web',
        devt:'web',
        os:navigator.userAgent.toLowerCase()
    };
    let paramsData = Object.assign(commonData,data);
    let params = {
        options:{
            url:'/resource/userdata?cmd=download&obj=orgcontacts',
            method:'post',
            data:JSON.stringify(paramsData)
        }
    };
    return fetch(params)
}
/*获取群成员信息*/
export function getGroupMember(data){
    let commonData = {
        cmd:'get',
        obj:'fixedgroups_user',
        tag:'',
        updatetime:0,
        ver:'1.0.0',
        dev:'web',
        devt:'web',
        os:navigator.userAgent.toLowerCase()
    };
    let paramsData = Object.assign(commonData,data);
    let params = {
        options:{
            url:'/resource/userdata?cmd=get&obj=fixedgroups_user',
            method:'post',
            data:JSON.stringify(paramsData)
        }
    };
    return fetch(params)
}
/*获取群协议*/
export  function getGroupInfo(data){
    let commonData = {
        cmd:'get',
        obj:'fixedgroups',
        tag:'',
        updatetime:0,
        ver:'1.0.0',
        dev:'web',
        devt:'web',
        os:navigator.userAgent.toLowerCase()
    };
    let paramsData = Object.assign(commonData,data);
    let params = {
        options:{
            url:'/resource/userdata?cmd=get&obj=fixedgroups',
            method:'post',
            data:JSON.stringify(paramsData)
        }
    };
    return fetch(params)
}
// 获取session
export function getKey(data){
    let params = {
        options:{
            url:'/login/ulogin/sessionKey/get?cmd=getSessionKey',
            method:'post',
            data:JSON.stringify(data)
        }
    };
    return fetch(params)
}
// 分组相关
//获取分组讨论详情
export function getCvmgDetail(data,url){
    let params = {
        options:{
            url:'/cvmg/info',
            method:'post',
            data:JSON.stringify(data)
        }
    };
    return fetch(params,url) 
}
// 创建分组
export function createGroup(data,url){
    let params = {
        options:{
            url:'/cvmg/group/create',
            method:'post',
            data:JSON.stringify(data)
        }
    };
    return fetch(params,url)
}
// 获取分组详情
export function getCvmgGroupDetail(data,url){
    let params = {
        options:{
            url:'/cvmg/group/info',
            method:'post',
            data:JSON.stringify(data)
        }
    };
    return fetch(params,url)
}
// 修改分组
export function modifyCvmgGroup(data,url){
    let params = {
        options:{
            url:'/cvmg/group/modify',
            method:'post',
            data:JSON.stringify(data)
        }
    };
    return fetch(params,url)
}  
// 删除分组
export function deleteCvmgGroup(data,url){
    let params = {
        options:{
            url:'/cvmg/group/delete',
            method:'post',
            data:JSON.stringify(data)
        }
    };
    return fetch(params,url)
} 
// 开始讨论
export function startGroup(data,url){
    let params = {
        options:{
            url:'/cvmg/group/start',
            method:'post',
            data:JSON.stringify(data)
        }
    };
    return fetch(params,url)
} 
// 结束讨论
export function stopGroup(data,url){
    let params = {
        options:{
            url:'/cvmg/group/stop',
            method:'post',
            data:JSON.stringify(data)
        }
    };
    return fetch(params,url)
} 
// 讨论组相关
// 创建讨论组
export function createGroupTeam(data,url){
    let params = {
        options:{
            url:'/cvmg/group/team/create',
            method:'post',
            data:JSON.stringify(data)
        }
    };
    return fetch(params,url)
}
// 获取讨论组详情
export function getGroupTeamDetail(data,url){
    let params = {
        options:{
            url:'/cvmg/group/team/info',
            method:'post',
            data:JSON.stringify(data)
        }
    };
    return fetch(params,url)
}
// 修改讨论组

export function modifyGroupTeam(data,url){
    let params = {
        options:{
            url:'/cvmg/group/team/modify',
            method:'post',
            data:JSON.stringify(data)
        }
    };
    return fetch(params,url)
}

// 删除讨论组
export function deleteGroupTeam(data,url){
    let params = {
        options:{
            url:'/cvmg/group/team/delete',
            method:'post',
            data:JSON.stringify(data)
        }
    };
    return fetch(params,url)
}

// 设置讨论组组长
export function setGroupTeamHost(data,url){
    let params = {
        options:{
            url:'/cvmg/group/team/user/set_host',
            method:'post',
            data:JSON.stringify(data)
        }
    };
    return fetch(params,url)
}

// 切换成员讨论组
export function changeUserTeam(data,url){
    let params = {
        options:{
            url:'/cvmg/group/team/user/change_team',
            method:'post',
            data:JSON.stringify(data)
        }
    };
    return fetch(params,url)
}

// 邀请主持人进组讨论
export function inviteHostToTeam(data,url){
    let params = {
        options:{
            url:'/cvmg/group/team/user/invite_host',
            method:'post',
            data:JSON.stringify(data)
        }
    };
    return fetch(params,url)   
}
// /cvmg/group/team/user/invite_feedback			
// 主持人同意或者拒绝进入某个讨论组

export function hostInviteFeedBack(data,url){
    let params = {
        options:{
            url:'/cvmg/group/team/user/invite_feedback',
            method:'post',
            data:JSON.stringify(data)
        }
    };
    return fetch(params,url)  
}

// 向分组投递消息

export function postMsgToTeam(data,url){
    let params = {
        options:{
            url:'/cvmg/group/post_message',
            method:'post',
            data:JSON.stringify(data)
        }
    };
    return fetch(params,url)  
}